import React from "react";
import { Table } from "react-bootstrap";
import ProductTagsTypes from "./ProductTagsTypes";
import { ProductTag } from "../actions/enums";

interface SwapsSummaryTableProps {
  swaps: any[];
  saleDetails?: any[];
}

const findSaleDetail = (saleDetails: any[] | undefined, saleDetailId: string) =>
  saleDetails?.find((d) => String(d.id) === String(saleDetailId));

const SwapsSummaryTable: React.FC<SwapsSummaryTableProps> = ({
  swaps,
  saleDetails,
}) => (
  <Table striped bordered size="sm" className="mb-3">
    <thead>
      <tr>
        <th>Original</th>
        <th></th>
        <th>Nuevo</th>
        <th>Cantidad</th>
      </tr>
    </thead>
    <tbody>
      {swaps.map((swap, idx) => {
        const saleDetail = findSaleDetail(saleDetails, swap.saleDetailId);
        const originalProduct = saleDetail?.product;
        return (
          <tr key={idx} style={{ background: "#f8f9fa" }}>
            <td>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div>
                  <div style={{ fontWeight: 500, fontSize: 14 }}>
                    {originalProduct?.name || swap.originalProductDescription}
                  </div>
                  {originalProduct?.typesTalle?.length > 0 && (
                    <ProductTagsTypes
                      types={originalProduct.typesTalle}
                      excludeTypes={[ProductTag.WEB]}
                    />
                  )}
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center", fontSize: 18 }}>→</td>
            <td>{swap.newProductDescription}</td>
            <td style={{ textAlign: "center" }}>{swap.quantity}</td>
          </tr>
        );
      })}
    </tbody>
  </Table>
);

export default SwapsSummaryTable;
